<template>
  <div class="p-2">
    <div class="start-chat-area">
      <div class="mb-1 start-chat-icon">
        <feather-icon
          icon="MailIcon"
          size="56"
        />
      </div>
      <div
        style="cursor: pointer"
        @click="ticketStore.setToggleLeftSidebar(true)"
      >
        <h4 class="sidebar-toggle start-chat-text ">
          {{ $t("ticket.select_massage_to_get_started") }}
        </h4>
      </div>

    </div>
    <!-- <p>{{ $t("ticket.select_massage_to_get_started") }}</p> -->
  </div>
</template>

<script>
import useTicketStore from '@/store-pinia/useTicketStore'

export default {
  setup() {
    const ticketStore = useTicketStore()
    return {
      ticketStore,
    }
  },
}
</script>

<style lang="scss">
.start-chat-area{
  text-align: center;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: calc(100vh - 200px);
}
.start-chat-icon{
  text-align: center !important;
    background: #faf7f7;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%) !important;
    border-radius: 61%;
    padding: 2rem;
    margin: 0;
    //position: absolute;
    top: 40%;
    left: 50%;
    //margin-right: -50%;
    //transform: translate(-50%, -50%)
  width: fit-content;

}
.start-chat-text{
    background: #faf7f7;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%) !important;
    border-radius: calc(0.357rem * 4);
    //position: absolute;
    left: 50%;
    top: 55%;
    //margin-right: -50%;
    //padding: 0.5rem 1rem;
    //transform: translate(-50%, -50%) ;
  width: fit-content;
  padding: 0.5rem 1rem;
}
.ticket-center-main {
     background-color: #f2f0f7;
}
</style>
